import { useRouter } from "next/router";
import { Button } from "./ui/button";
import { useAtom } from "jotai";
import { loginPopup, registerPopup } from "@/Atoms";

function ReadMoreLogin() {
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const [openRegisterPopup, setOpenRegisterPopup] = useAtom(registerPopup);
  const router = useRouter();
  const currentPath = router.asPath;

  function toLogin() {
    router.push(`/auth/login?redirect_to=${currentPath}`);
  }
  function toCreateAccount() {
    router.push(`/register?redirect_to=${currentPath}`);
  }

  const onLogin = () => {
    setOpenLoginPopup(true)
  }

  return (
    <div className='text-center'>
      <h2 className='mb-2 text-2xl font-bold'>Register &amp; Read for Free</h2>
      <p className='text-sm text-white/50'>
        Just login or create a free account to enjoy our content
      </p>
      <div className='flex items-center justify-center gap-3 mt-5'>
        <Button onClick={onLogin}>Login</Button>
        <span>or</span>
        <Button variant='outline' onClick={() => setOpenRegisterPopup(true)}>
          Register
        </Button>
      </div>
    </div>
  );
}

export default ReadMoreLogin;
